import { ApiError } from "../../api/apiError";
import { requestErrorText } from "../queue/requestErrorText";
import type { TFunction } from "../queue/requestErrorText";

// Пары `[status, code]` отказов ручек ролей агентов
// (`docs/spec/modules/agent_governance.md` § «Отказы»); `permission_denied` —
// код ядра.
const REFUSALS: readonly (readonly [number, string])[] = [
  [404, "agent_role_not_found"],
  [422, "empty_prompt"],
  [422, "model_not_supported"],
  [409, "no_provider_selected"],
  [409, "unknown_provider"],
  [403, "permission_denied"],
];

function modelNotSupportedText(
  data: Readonly<Record<string, unknown>>,
  t: TFunction,
): string {
  const { model, allowed } = data;
  if (
    typeof model === "string" &&
    Array.isArray(allowed) &&
    allowed.length > 0 &&
    allowed.every((item) => typeof item === "string")
  ) {
    return t("agentRoles.refusal.model_not_supported", {
      model,
      allowed: allowed.join(", "),
    });
  }
  return t("agentRoles.refusal.model_not_supported_bare");
}

// Текст отказа по паре статус + `code`; прочее — общий текст по статусу или
// «нет связи». `message` сервера и технический `message` ошибки не выводятся.
export function agentRoleErrorText(error: unknown, t: TFunction): string {
  if (
    error instanceof ApiError &&
    REFUSALS.some(
      ([status, code]) => status === error.status && code === error.code,
    )
  ) {
    if (error.code === "model_not_supported") {
      return modelNotSupportedText(error.data, t);
    }
    return t(`agentRoles.refusal.${error.code}`);
  }
  return requestErrorText(error, t);
}
